import { FunctionComponent, useMemo } from 'react';
import className from './MicrophonePermissionsInfo.module.scss';
import classes from 'classnames';
import SVG from 'react-inlinesvg';
import Group from '@/assets/svg/Group.svg';
import { useTranslation } from 'react-i18next';
import TheButton from '@/components/TheButton/TheButton';
import commonUtils from '@/utils/common';

export enum MicrophoneErrorTypes {
  permissions = 'permissions',
  device_not_found = 'deviceNotFound',
  device_in_use = 'deviceInUse',
  failed_to_access_the_device = 'failedToAccessTheDevice',
}

interface Props {
  onClose: () => void;
  fromQuiz?: boolean;
  skipAllSpeechRecordingQuestions?: () => void;
  errorType: MicrophoneErrorTypes;
}

const MicrophonePermissionsInfo: FunctionComponent<Props> = ({
  onClose,
  fromQuiz,
  skipAllSpeechRecordingQuestions,
  errorType,
}) => {
  const { t } = useTranslation();

  const guide = useMemo(() => {
    const getPermissionsGuideKey = () => {
      let permissionsGuideKey: string = 'default';
      const browserData = commonUtils.getBrowserData();

      if (browserData.isIOS) {
        permissionsGuideKey = 'ios';
      } else if (browserData.isAndroid) {
        permissionsGuideKey = 'android';
      } else if (browserData.isChrome) {
        permissionsGuideKey = 'chrome';
      } else if (browserData.isFirefox) {
        permissionsGuideKey = 'firefox';
      } else if (browserData.isEdge) {
        permissionsGuideKey = 'edge';
      } else if (browserData.isSafari) {
        permissionsGuideKey = 'safari';
      }

      return `MicrophoneInfoGuide.${permissionsGuideKey}`;
    };

    const guideKey: string =
      errorType === MicrophoneErrorTypes.permissions
        ? getPermissionsGuideKey()
        : `MicrophoneInfoErrors.${errorType}`;

    return (
      <div
        className={className.guide}
        dangerouslySetInnerHTML={{ __html: t(guideKey).toString() }}
      />
    );
  }, [t, errorType]);

  return (
    <div className={className.banner}>
      <SVG src={Group} />
      <div className={className.frameParent}>
        <div className={className.weWantToHearYouWrapper}>
          <div className={className.weWantTo}>{t('MicrophoneInfoWeWantTo')}</div>
        </div>
        <div className={className.inOrderTo}>
          {fromQuiz ? t('MicrophoneInfoInOrderToQuiz') : t('MicrophoneInfoInOrderTo')}
        </div>
      </div>

      {guide}

      <div className={className.buttons}>
        <TheButton
          emitOnClick={onClose}
          text={fromQuiz ? t('resolved') : t('homepage')}
          shouldRecolor={fromQuiz}
          showArrow={fromQuiz}
          className={classes({
            [className.fixColor]: !fromQuiz,
          })}
        />
        {skipAllSpeechRecordingQuestions && (
          <TheButton
            className={className.skipBtn}
            emitOnClick={skipAllSpeechRecordingQuestions}
            text={t('skipAllRecording')}
            shouldRecolor={false}
          />
        )}
      </div>
    </div>
  );
};

export default MicrophonePermissionsInfo;
